import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { Email } from 'app/pechkin/test/services/email';
import { Sms } from 'app/pechkin/test/services/sms';

@Injectable()
export class PechkinService {
  protected baseUrl = `${environment.pechkinApi}`;

  constructor(private http: HttpClient) {}

  sendEmail(email: Email): Observable<any> {
    const url = this.baseUrl;
    return this.http.post(`${url}/emails`, email);
  }

  sendSms(sms: Sms): Observable<any> {
    const url = this.baseUrl;
    return this.http.post(`${url}/sms`, sms);
  }
}
